export default __webpack_public_path__ + "static/media/Snake.c0691af3.png";